import { useAuth, useLoginWithRedirect } from "@frontegg/react";
import { Lock } from "lucide-react";
import Logo from "../../../../assets/images/Logo.svg";
import CustomLink from "./custom-link";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Login_Comp() {
  const { isAuthenticated } = useAuth();
  const loginWithRedirect = useLoginWithRedirect();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/home");
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = () => {
    loginWithRedirect();
  };

  return (
    <div className="min-h-screen bg-[#090e21] flex items-center justify-center p-8">
      <div className="w-full max-w-2xl bg-[#05050f] backdrop-blur-lg rounded-3xl p-12 shadow-2xl border border-[#1D2232]">
        <div className="flex flex-col items-center space-y-6">
          <img
            src={Logo}
            alt="FixFinder Logo"
            className="w-[320px] h-[70px] animate-fade-in"
          />

          <h2 className="text-[#c0cde0] text-center text-[32px] font-[600] gradient-clr-txt leading-[1.2]">
            Product Research Portal
          </h2>

          <p className="text-[#c0cde0] text-[18px] font-[300] leading-[1.6] !mt-[20px] text-center max-w-lg">
            Access our innovative solutions, prototypes, and product
            demonstrations.
          </p>

          <div className="w-full space-y-4">
            <button
              onClick={handleLogin}
              className="group relative w-full max-w-[280px] mx-auto flex items-center justify-center px-6 py-3 bg-gradient-btn text-white text-sm font-semibold rounded-lg overflow-hidden transition-all duration-300 hover:from-blue-600 hover:to-emerald-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900"
            >
              <div className="absolute inset-0 w-3 bg-gradient-to-r from-white/0 via-white/20 to-white/0 skew-x-[-45deg] group-hover:animate-shimmer" />
              <Lock className="w-4 h-4 mr-2" />
              Single Sign-On
            </button>

            <div className="flex flex-col items-center space-y-2">
              <a
                href="/signup"
                className="text-[#0193F8] hover:text-[#0173C8] text-sm font-medium transition-colors mt-[5px]"
              >
                Apply for Access
              </a>
            </div>
          </div>

          <CustomLink
            href="/terms"
            text="Terms of Use"
            margin="mt-6"
          />
        </div>
      </div>
    </div>
  );
}

export default Login_Comp;
